import type { LobbySettings } from "@rosette/ts/src/business/game/LobbySettings.js";
import type { GameAPI } from "@rosette/ts/src/business/api/GameAPI.js";
import { matomo } from "@/components/Matomo.js";
import type { AppRouterInstance } from "next/dist/shared/lib/app-router-context.shared-runtime";
import { KnownLobbySettings } from "@rosette/ts/src/business/game/KnownLobbySettings.js";
import type { APIUser } from "@rosette/ts/src/business/api/api_schema.js";
import { GameMode } from "@rosette/ts/src/business/game/GameMode.js";


export async function startRemoteGame(
    router: AppRouterInstance,
    user: APIUser | null,
    settings: LobbySettings,
    gameAPI: GameAPI,
): Promise<void> {
    const lobbyID = settings.getLobbyID();
    if (lobbyID) {
        router.push(`/game/${lobbyID}`);
        return;
    }
    if (!(settings instanceof KnownLobbySettings))
        throw new Error("Expected known game setup settings");
    if (!settings.isRemote())
        throw new Error("Expected remote game setup settings");

    const mode = settings.getMode();
    if (mode === GameMode.ONLINE || mode === GameMode.RANKED) {
        router.push("/");
        return;
    }

    const response = await gameAPI.createGame(
        settings.getMode(), settings.getGameSettings(), settings.getBotType(),
    );
    matomo.recordCreateLobby(settings);
    router.push(`/game/${response.lobby_id}`);
}
